import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OrderFrequencySlice, OrderFrequencyValue } from './order-frequency-types'

const INITIAL_STATE: OrderFrequencySlice = { value: 'one-time' }

const orderFrequencySlice = createSlice({
  name: 'frequency',
  initialState: INITIAL_STATE,
  reducers: {
    setValue: (state, action: PayloadAction<OrderFrequencyValue>) => {
      return { ...state, value: action.payload }
    },
  },
})

export default orderFrequencySlice
